import { render, staticRenderFns } from "./SiteMasthead.vue?vue&type=template&id=36a5baf8&scoped=true&"
import script from "./SiteMasthead.vue?vue&type=script&lang=ts&"
export * from "./SiteMasthead.vue?vue&type=script&lang=ts&"
import style0 from "./SiteMasthead.vue?vue&type=style&index=0&id=36a5baf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a5baf8",
  null
  
)

export default component.exports